<form (ngSubmit)="onSave()" *ngIf="ngFormGroup" matForm [formGroup]="ngFormGroup" style="height: auto;">
    <div class="form configuration-popup" *ngIf="NgFormGroup != null">
        <div class="config-section">
            <h2>Common Options</h2>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Display Name</mat-label>
                    <input matInput placeholder="Name" formControlName="displayName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Internal Name</mat-label>
                    <input matInput formControlName="name" (ngModelChange)="handleModelChange('name')" />
                </mat-form-field>
                <small class="property-error-message property-red">
                    {{this.FieldNameErrorMsg}}
                </small>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Tool Tip</mat-label>
                    <input matInput formControlName="toolTip" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Placeholder</mat-label>
                    <input matInput formControlName="placeholderText" />
                </mat-form-field>
            </div>
            <div>
                <mat-label>Instructions</mat-label>
                <kendo-editor name="kendo-editor" formControlName="instructionsText"></kendo-editor>
            </div>
            <div>
                <div class="pad-top-10">
                    <div class="pad-right-25" style="float:left;">
                        Footnote<br />
                        <mat-button-toggle-group formControlName="hasFootnote">
                            <mat-button-toggle [value]="true">Show</mat-button-toggle>
                            <mat-button-toggle [value]="false">Hide</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div>
                        Required<br />
                        <mat-button-toggle-group formControlName="required">
                            <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                            <mat-button-toggle [value]="false">No</mat-button-toggle>
                        </mat-button-toggle-group><br />
                        <!--Consider Use an info icon to display the tip below-->
                        <!--<small>Require that this control contains information</small>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="config-section">
            <h2>Field Type Options</h2>
            <div *ngIf="FieldColumnPairs.length > 0">
                <div class="field-column-pairs">
                    <div><strong>Constraint</strong></div>
                    <div><strong>Column</strong></div>
                    <div></div>
                </div>
                <div *ngFor="let pair of FieldColumnPairs">
                    <div class="field-column-pairs">
                        <div title="{{pair.constraintName}}">
                            {{pair.constraintName}}
                        </div>
                        <div title="{{pair.listConstraintColumnName}}">
                            {{pair.listConstraintColumnName}}
                        </div>
                        <div>
                            <button mat-icon-button
                                    style="bottom: 8px;"
                                    type="button"
                                    (click)="deleteFCpair(pair)"
                                    (keyup.enter)="deleteFCpair(pair)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <br />
            </div>

            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select a constraint</mat-label>
                    <mat-spinner [diameter]="25" *ngIf="this.LoadingConstraints"></mat-spinner>
                    <mat-select name="selectConstraint" formControlName="selectedConstraintName" (selectionChange)="onSelectConstraint($event)">
                        <mat-option *ngFor="let con of Constraints"
                                    title="{{con.name}}"
                                    [value]="con.name">
                            {{con.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select constraint column</mat-label>
                    <mat-spinner [diameter]="25" *ngIf="this.LoadingColumns"></mat-spinner>
                    <mat-select name="selectColumn" formControlName="selectedConstraintColumnName" (selectionChange)="onSelectColumn($event)">
                        <mat-option *ngFor="let col of Columns"
                                    title="{{col.name}}"
                                    [value]="col.name">
                            {{col.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div>
                <!--
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="narrow-form-field">
                    <mat-label>Minimum Selections</mat-label>
                    <input matInput formControlName="minimumSelections" type="number" min="0" value="0" />
                </mat-form-field>
                &nbsp;
                -->
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="narrow-form-field">
                    <mat-label>Maximum Selections</mat-label>
                    <input matInput formControlName="maximumSelections" type="number" min="0" />
                </mat-form-field>
            </div>

            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select Source Field</mat-label>
                    <mat-select formControlName="dependsOnParentFormFieldName" (selectionChange)="onSelectSourceField($event)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let src of AvailableSourceFields"
                                    title="{{src.displayName}}"
                                    [value]="src.name">
                            <span *ngIf="src.displayName">{{src.displayName}}</span>
                            <span *ngIf="!src.displayName">{{src.name}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Default Value</mat-label>
                    <input matInput formControlName="defaultValue" />
                </mat-form-field>
            </div>
            <!--The following can be used to change the default value to a dropdown-->
            <!--<div>
                <mat-form-field appearance="outline" [floatLabel]="'always'" class="width-100">
                    <mat-label>Select Default Value</mat-label>
                    <mat-select name="selectDefaultValue">
                        <mat-option *ngFor="let opt of AvailableDefaultValues"
                                    title="{{opt.value}}"
                                    [value]="opt.value">
                            {{opt.value}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>-->
            <div>
                Autocomplete<br />
                <mat-button-toggle-group formControlName="autoCompleteEnabled">
                    <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                    <mat-button-toggle [value]="false">No</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
        <div class="config-section" style="display: none;">
            <h2>Preview</h2>
        </div>
    </div>
    <div class="bottom-buttons">
        <button mat-raised-button type="submit" color="primary" title="field ID {{this.formField.id}}"
                [mat-dialog-close]=""
                [disabled]="this.FieldNameErrorMsg != null">
            Save Template
        </button>
        &nbsp;
        <button mat-raised-button type="button" color="secondary" [mat-dialog-close] (click)="cancelClicked()">Cancel</button>
    </div>
</form>
